export default __webpack_public_path__ + "static/media/file-signature-regular.ea114ca7.svg";